"use client";
import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Image from "next/image";
import Link from "next/link";

const ReviewProgress = ({
  hotel,
  loading,
}: {
  hotel: any;
  loading: boolean;
}) => {
  return (
    <>
      {/* {JSON.stringify(hotel?.tripadvisor_data)} */}
      {hotel?.tripadvisor_data && (
        <>
          <div className="row">
            <div className="col-12">
              <h3 className="text-22 fw-500">Guest reviews</h3>
            </div>
          </div>

          <div className="row y-gap-30 items-center pt-20 mb-30">
            <div className="col-lg-3">
              <div className="flex-center rounded-4 min-h-250 bg-blue-1-05">
                <div className="text-center">
                  <div className="text-60 md:text-50 fw-600 text-blue-1">
                    {loading ? (
                      <Skeleton width={60} height={50} />
                    ) : (
                      hotel?.tripadvisor_data?.rating
                    )}
                  </div>
                  {loading ? (
                    <Skeleton width={80} />
                  ) : (
                    hotel?.tripadvisor_data && (
                      <div className="lh-15 fw-500">
                         <Link href={`${hotel?.tripadvisor_data?.web_url}`} target="_blank">
                        <Image
                          src={hotel?.tripadvisor_data?.rating_image_url}
                          alt="Rating image"
                          width={100}
                          height={100}
                        />
                        </Link>
                      </div>
                    )
                  )}

                  <div className="text-14 text-light-1 lh-1 mt-5">
                    {loading ? (
                      <Skeleton width={80} />
                    ) : (
                      <>
                       <Link href={`${hotel?.tripadvisor_data?.web_url}`} target="_blank">
                          {hotel?.tripadvisor_data?.num_reviews} reviews
                       </Link>
                      </>
                      
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* End .col-lg-3 */}

            <div className="col-lg-9">
              <div className="row y-gap-30">
                {loading
                  ? Array.from({ length: 6 }).map((_, index) => (
                      <div className="col-md-4 col-sm-6" key={index}>
                        <div className="d-flex items-center justify-between">
                          <Skeleton width={100} height={15} />
                          <Skeleton width={30} height={15} />
                        </div>
                        <div className="progressBar mt-10">
                          <Skeleton height={15} width="100%" />
                        </div>
                      </div>
                    ))
                  : hotel?.tripadvisor_data?.subratings &&
                    Object.keys(hotel?.tripadvisor_data?.subratings).map(
                      (key: any) => {
                        const item = hotel?.tripadvisor_data?.subratings[key];
                        return (
                          <div className="col-md-4 col-sm-6" key={item?.name}>
                            <div className="d-flex items-center justify-between">
                              <div className="text-15 fw-500">
                                {item?.localized_name}
                              </div>
                              <div className="text-15 text-light-1">
                                {item?.value}
                              </div>
                            </div>
                            <div className="progressBar mt-10">
                              <div className="progressBar__bg bg-blue-2" />
                              <div
                                className="progressBar__bar bg-dark-1"
                                style={{ width: 50 * item?.value }}
                              />
                            </div>
                          </div>
                        );
                      }
                    )}
              </div>
              {/* End .row */}
            </div>
            {/* End .col-lg-9 */}
          </div>
        </>
      )}

      {/* End .row */}
    </>
  );
};

export default ReviewProgress;
